import React, { useEffect, useState } from 'react';
import { Box, MenuItem, TextField } from '@mui/material';
import { PrimaryButton, SecondaryButton } from '../../atoms/Button';

interface PurchaseStatusFilterProps {
  selectedStatus: string;
  statusOptions: Array<{ value: string; label: string }>;
  onFiltered: (status: string) => void;
  onResetFilter: () => void;
  handleDrawerClose?: () => void;
}

const PurchaseStatusFilter: React.FC<PurchaseStatusFilterProps> = ({
  selectedStatus,
  statusOptions,
  onFiltered,
  onResetFilter,
  handleDrawerClose,
}) => {
  const [status, setStatus] = useState(selectedStatus);

  useEffect(() => {
    setStatus(selectedStatus);
  }, [selectedStatus]);

  const handleApply = () => {
    onFiltered(status);
    handleDrawerClose?.();
  };

  const handleReset = () => {
    setStatus('ALL');
    onResetFilter();
    handleDrawerClose?.();
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        select
        label="Status"
        value={status}
        onChange={(e) => setStatus(e.target.value)}
        fullWidth
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#222',
            color: '#fff',
          },
          '& .MuiInputLabel-root': {
            color: '#8A8D91',
          },
        }}
      >
        {statusOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>

      <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
        <SecondaryButton title="Reset" onClick={handleReset} />
        <PrimaryButton title="Apply Filter" onClick={handleApply} />
      </Box>
    </Box>
  );
};

export default PurchaseStatusFilter;
